import { ComponentSize, PracticeProspect, TextColor } from '../../../types';
import { ButtonColor, ButtonVariant, ProspectDetails, TextButton, Typography } from '../../shared';
import { TypographyType } from '../../shared/Typography/Typography.types';

export type NextProspectDetails = {
  prospect: PracticeProspect;
  isFirst: boolean;
};

interface UpNextProps {
  callNextProspect: () => void;
  exitCall: () => void;
  nextProspectDetails?: NextProspectDetails;
}

const UpNext = ({ callNextProspect, exitCall, nextProspectDetails }: UpNextProps) => {
  const renderExitButton = () => (
    <TextButton
      text="Exit"
      color={ButtonColor.NEUTRAL}
      size={ComponentSize.X_SMALL}
      variant={ButtonVariant.SOFT}
      fullWidth
      onClick={exitCall}
    />
  );

  if (!nextProspectDetails) {
    return renderExitButton();
  }

  const { prospect, isFirst } = nextProspectDetails;
  const { firstName, lastName, accountName, jobTitle } = prospect;

  return (
    <div className="relative flex items-center justify-between gap-4 rounded-[4px] border border-primary p-4">
      <span className="left-1/5 absolute -top-2 transform bg-white px-2">
        <Typography color={TextColor.SECONDARY} type={TypographyType.X_SMALL}>
          {isFirst ? 'From the top' : 'Up next'}
        </Typography>
      </span>
      <ProspectDetails firstName={firstName} lastName={lastName} accountName={accountName} jobTitle={jobTitle} />
      <div className="flex flex-col gap-2">
        <TextButton size={ComponentSize.X_SMALL} text="Start call" onClick={callNextProspect} />
        {renderExitButton()}
      </div>
    </div>
  );
};

export default UpNext;
